// third-party
import { createSlice } from "@reduxjs/toolkit";

// types
type PatientState = {
  error: string | null;
  patient: [
    {
      earliestValue: number;
      day: string;
      hourBucket: string;
      readings: number[];
      startHour: number;
      type: string;
    }
  ];
};

const initialState: PatientState = {
  error: null,
  patient: [
    {
      earliestValue: 0,
      day: "",
      hourBucket: "",
      readings: [],
      startHour: 0,
      type: "",
    },
  ],
};

const slice = createSlice({
  name: "patient",
  initialState,
  reducers: {
    setPatient: (state, action) => {
      state.patient = action.payload;
    },
    updatePatient: (state, action) => {
      if (state.patient) {
        state.patient = { ...state.patient, ...action.payload };
      }
    },
    clearPatient: (state) => {
      state.patient = initialState.patient;
    },
  },
});

// Reducer
export default slice.reducer;

export const { clearPatient, setPatient, updatePatient } = slice.actions;
